import React from "react"
import Text from "components/Text/Text"
import alertModals from "stores/alertModals"
import { useList } from 'effector-react'
import AlertModal, { IAlertModalProps } from "components/AlertModal/AlertModal"
import useLocationChange from "hooks/useLocationChange"

const AlertModals = () => {
    useLocationChange(alertModals.clear)

    async function handleClose(props: IAlertModalProps) {
        if (typeof props.onClose === "function") {
            await props.onClose()
        }
        alertModals.hide(props)
    }

    return useList(alertModals.list, (props: IAlertModalProps, idx) => (
        <AlertModal
            {...props}
            onClose={() => handleClose(props)}
            key={idx}>
            <Text>{props.children}</Text>
        </AlertModal>
    ))
}

export default AlertModals
